import { NsInput } from 'components/common/ns-input/NsInput';
import { NsInputter } from 'components/common/ns-inputter/NsInputter';
import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import { useMaskPII } from 'hooks/useMaskPII';
import NsInputterEvent from 'components/common/ns-inputter/NsInputterEvent';

type NsMpanInputProps = {
  value?: string;
  name?: string;
  label?: string;
  helpText?: string;
  onChange?: (event: NsInputterEvent) => void;
};

export const NsMpanInput = ({
  value,
  name = 'MPAN',
  label = 'MPAN',
  helpText,
  onChange
}: NsMpanInputProps) => {
  const { mask } = useMaskPII();
  const validation = [
    NsInputterValidations.isRequired,
    NsInputterValidations.isInteger,
    NsInputterValidations.minLength(13),
    NsInputterValidations.maxLength(13)
  ];

  return (
    <NsInputter
      name={name}
      helper={helpText}
      value={value}
      onChange={onChange}
      validation={validation}
    >
      <NsInput
        id={name}
        name={name}
        label={label}
        pattern="^[0-9]{13}$"
        inputAttributes={mask}
        placeholder="13 digits"
      />
    </NsInputter>
  );
};
